export const TOOLBAR_DATA_HOOK = 'toolbar-v3';
export const TOOLBAR_VISIBLE = 'toolbar-v3-visible';
